<template>
  <div :class="{'is-active':isActive}">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Tab',
  
  props: {
    name: { 
      required: true
    },
    selected: {
      default: false
    }
  },

  data() {
    return {
      isActive: false
    };
  },

  created() {
    this.$parent.tabs.push(this);
  },
  
  mounted() {
    this.isActive = this.selected;
  },
}
</script>
